import React, { useState } from "react";
import { withTranslation, Trans } from "react-i18next";
import { connect } from "react-redux";
import { isEmpty } from 'lodash'


class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    if (this.props.OrderHistoryListLoading && isEmpty(this.props.OrderHistoryList)) {
      return (
        <div className="NoOrderContainer">
          <div className="NoOrderInner mrb90">
          <div className="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div> 
            <span className="NoOrderTitle">
              {" "}
              <Trans i18nKey={"loadingList"}> </Trans>{" "}
            </span>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => ({
  open: state.OrderHistory.OrderListOpenDialoge,
  OrderHistoryList: state.OrderHistory.OrderHistoryList,
  OrderHistoryListLoading: state.OrderHistory.OrderHistoryListLoading,
  OrderHistoryListError: state.OrderHistory.OrderHistoryListError,
  page: state.OrderHistory.page,

});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(App));
